// Header starts
$(document).ready(function(){
  $(".es_header-button__search").click(function(){
    $(this).toggleClass("active");
    $(".es_header-search__details").toggleClass("active");
  });

  $(".es_header-button__user").click(function(){
    $(this).toggleClass("active");
    $(".es_header-user__details").toggleClass("active");
  });

  $(".es_header-button__cart, .cart-drawer__overlay").click(function(){
    $(".es_cart-drawer").toggleClass("animate");
    $(".es_cart-drawer").toggleClass("active");
  });

  $(".cart-drawer__overlay").click(function(){
    this.closest("cart-drawer").close();
  });

  $(".es_header-button__hamburger").click(function(){
    $(this).toggleClass("active");
    $(".es_header-menu").slideToggle(250);
    $('.es_header-menu__parent-c').removeClass('active')
    $('.es_header-menu__box').slideUp(250);
    $('.es_header-menu__child-c').removeClass('active')
    $('.es_header-menu__gbox').slideUp(250);
  });

  $('.es_header-menu__parent-c > .es_header-menu__parent-ca').on('click', function (e) {
    const parentItem = $(this).closest('.es_header-menu__parent-c');
    const submenu = parentItem.children('.es_header-menu__box');

    if (!submenu.length) return;

    e.preventDefault();

    if (parentItem.hasClass('active')) {
      parentItem.removeClass('active');
      submenu.stop(true, true).slideUp(250);
      return;
    }

    $('.es_header-menu__parent-c.active')
      .removeClass('active')
      .children('.es_header-menu__box')
      .stop(true, true)
      .slideUp(250);

    parentItem.addClass('active');
    submenu.stop(true, true).slideDown(250);
  });

  $('.es_header-menu__child-c > .es_header-menu__child-ca').on('click', function (e) {
    const childItem = $(this).closest('.es_header-menu__child-c');
    const grandchildmenu = childItem.children('.es_header-menu__gbox');

    if (!grandchildmenu.length) return;

    e.preventDefault();

    if (childItem.hasClass('active')) {
      childItem.removeClass('active');
      grandchildmenu.stop(true, true).slideUp(250);
      return;
    }

    $('.es_header-menu__child-c.active')
      .removeClass('active')
      .children('.es_header-menu__gbox')
      .stop(true, true)
      .slideUp(250);

    childItem.addClass('active');
    grandchildmenu.stop(true, true).slideDown(250);
  });
});
// Header ends



// Footer starts
$(document).ready(function () {
  const footerCheckbox = $('.es_footer-newsletter__checkbox');
  const footerButton = $('.es_footer-newsletter__button');

  function footerToggleButtonState() {
    if (footerCheckbox.is(':checked')) {
      footerButton.prop('disabled', false).removeClass('is-disabled');
    } else {
      footerButton.prop('disabled', true).addClass('is-disabled');
    }
  }

  footerToggleButtonState();

  footerCheckbox.on('change', footerToggleButtonState);
});
// Footer ends



// Slideshow starts
// document.addEventListener('DOMContentLoaded', () => {
//   const heroCard = document.querySelector('.header139_card');
//   if (!heroCard) return;

//   if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
//     heroCard.style.transform = 'translate3d(0, -5vh, 0)';
//     heroCard.style.width = '100%';
//     heroCard.style.height = '100vh';
//     return;
//   }

//   heroCard.style.willChange = 'transform, width, height';
//   heroCard.style.transformStyle = 'preserve-3d';

//   const START_TRANSLATE = -7.5;
//   const END_TRANSLATE = -5;

//   const START_SIZE = 97.5;
//   const END_SIZE = 100;

//   const ANIMATION_DISTANCE = 150;

//   let startScroll = null;

//   function applyStyles(progress) {
//     const translateY =
//       START_TRANSLATE +
//       (END_TRANSLATE - START_TRANSLATE) * progress;

//     const size =
//       START_SIZE +
//       (END_SIZE - START_SIZE) * progress;

//     heroCard.style.transform = `
//       translate3d(0px, ${translateY}vh, 0px)
//       scale3d(1,1,1)
//       rotateX(0deg) rotateY(0deg) rotateZ(0deg)
//       skew(0deg,0deg)
//     `;

//     heroCard.style.width = `${size}%`;
//     heroCard.style.height = `${size}vh`;
//   }

//   function update() {
//     const rect = heroCard.getBoundingClientRect();
//     const scrollY = window.scrollY;

//     if (rect.top <= 0 && startScroll === null) {
//       startScroll = scrollY;
//     }

//     if (startScroll !== null && scrollY < startScroll) {
//       startScroll = null;
//       applyStyles(0);
//       return;
//     }

//     if (startScroll === null) {
//       applyStyles(0);
//       return;
//     }

//     const rawProgress =
//       (scrollY - startScroll) / ANIMATION_DISTANCE;

//     const progress = Math.min(Math.max(rawProgress, 0), 1);

//     applyStyles(progress);
//   }

//   window.addEventListener('scroll', () => {
//     requestAnimationFrame(update);
//   });

//   update();
// });
// Slideshow ends



// Featured products starts
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const ec_Featured_Products = document.querySelectorAll('.ec_featured_products');

    ec_Featured_Products.forEach((feature, index) => {
      const fsliderEl = feature.querySelector('.ec_featured_products-swiper');
      if (!fsliderEl) return;

      const fpaginationEl = feature.querySelector('.ec_featured_products-pagination');

      new Swiper(fsliderEl, {
        loop: true,
        slidesPerView: 1.2,
        spaceBetween: 20,
        speed: 700,
        pagination: {
          el: fpaginationEl,
          clickable: true
        },
        breakpoints: {
          480: {
            slidesPerView: 1.6
          },
          769: {
            slidesPerView: 2.2
          },
        },
        on: {
          init() {
            this.update();
          }
        }
      });
    });
  });
})();
// Featured products ends



// System starts
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const ec_system = document.querySelectorAll('.ec_system-inner');

    ec_system.forEach((system, index) => {
      const ssliderEl = system.querySelector('.ec_system-swiper');
      if (!ssliderEl) return;

      const spaginationEl = system.querySelector('.ec_system-pagination');

      new Swiper(ssliderEl, {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 20,
        speed: 700,
        pagination: {
          el: spaginationEl,
          clickable: true
        },
        breakpoints: {
          480: {
            slidesPerView: 1.6
          },
          769: {
            slidesPerView: 2.2
          },
        },
        on: {
          init() {
            this.update();
          }
        }
      });
    });
  });
})();
// System ends



// Overview starts
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const ec_overview = document.querySelectorAll('.ec_overview');

    ec_overview.forEach((overview, index) => {
      const osliderEl = overview.querySelector('.ec_overview-swiper');
      if (!osliderEl) return;

      const opaginationEl = overview.querySelector('.ec_overview-pagination');

      new Swiper(osliderEl, {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 20,
        speed: 700,
        pagination: {
          el: opaginationEl,
          clickable: true
        },
        breakpoints: {
          480: {
            slidesPerView: 1.6
          },
          769: {
            slidesPerView: 2.2
          },
        },
        on: {
          init() {
            this.update();
          }
        }
      });
    });
  });
})();
// Overview ends



// System 2 starts
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const ec_system2 = document.querySelectorAll('.ec_system_2');

    ec_system2.forEach((system2, index) => {
      const ssliderEl2 = system2.querySelector('.ec_system_2-swiper');
      if (!ssliderEl2) return;

      const spaginationEl2 = system2.querySelector('.ec_system_2-pagination');

      new Swiper(ssliderEl2, {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 20,
        speed: 700,
        pagination: {
          el: spaginationEl2,
          clickable: true
        },
        breakpoints: {
          480: {
            slidesPerView: 1.6
          },
          769: {
            slidesPerView: 2.2
          },
        },
        on: {
          init() {
            this.update();
          }
        }
      });
    });
  });
})();
// System 2 ends



// Overview 2 starts
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const ec_overview2 = document.querySelectorAll('.ec_overview_2');

    ec_overview2.forEach((overview2, index) => {
      const osliderEl2 = overview2.querySelector('.ec_overview_2-swiper');
      if (!osliderEl2) return;

      const opaginationEl2 = overview2.querySelector('.ec_overview_2-pagination');

      new Swiper(osliderEl2, {
        loop: false,
        slidesPerView: 1.1,
        spaceBetween: 20,
        speed: 700,
        pagination: {
          el: opaginationEl2,
          clickable: true
        },
        breakpoints: {
          769: {
            slidesPerView: 1.2,
          },
        },
        on: {
          init() {
            this.update();
          }
        }
      });
    });
  });
})();
// Overview 2 ends



// Double tabs starts
$(document).ready(function () {
  $('.product-tabs .w-tab-link').on('click', function (e) {
    e.preventDefault();

    const tabName = $(this).attr('data-w-tab');
    const $tabsWrapper = $(this).closest('.product-tabs');

    $tabsWrapper.find('.w-tab-link').removeClass('w--current');
    $(this).addClass('w--current');

    $tabsWrapper.find('.w-tab-pane').removeClass('w--tab-active');
    $tabsWrapper.find('.w-tab-pane[data-w-tab="' + tabName + '"]')
      .addClass('w--tab-active');
  });
});
// Double tabs ends



// Innovation starts
document.addEventListener('DOMContentLoaded', () => {
  function verticalLoop(selector, speed = 0.03, resetAt = -50) {
    const el = document.querySelector(selector);
    if (!el) return;

    let offset = 0;

    function loop() {
      offset -= speed;
      if (offset <= resetAt) offset = 0;

      el.style.transform = `translate3d(0, ${offset}%, 0)`;
      requestAnimationFrame(loop);
    }

    loop();
  }

  verticalLoop('.es_innovation-list__1', 0.03);
  verticalLoop('.es_innovation-list__2', 0.03);
});
// Innovation ends



// Tabs starts
(function () {
  const ecTabsInit = () => {
    const ecTabTriggers = document.querySelectorAll('[data-ec-tab-trigger]');

    if (!ecTabTriggers.length) return;

    ecTabTriggers.forEach((ecTrigger) => {
      ecTrigger.addEventListener('click', function (event) {
        event.preventDefault();

        const ecTabIndex = this.getAttribute('data-ec-tab-trigger');
        if (!ecTabIndex) return;

        const ecTabsWrapper = this.closest('.w-tabs');
        if (!ecTabsWrapper) return;

        const ecTabLinks = ecTabsWrapper.querySelectorAll('.w-tab-link');
        const ecTabPanes = ecTabsWrapper.querySelectorAll('.w-tab-pane');

        ecTabLinks.forEach((link) => link.classList.remove('w--current'));
        ecTabPanes.forEach((pane) => pane.classList.remove('w--tab-active'));

        this.classList.add('w--current');

        const ecActivePane = ecTabsWrapper.querySelector(
          `.w-tab-pane[data-w-tab="${ecTabIndex}"]`
        );

        if (ecActivePane) {
          ecActivePane.classList.add('w--tab-active');
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ecTabsInit);
  } else {
    ecTabsInit();
  }
})();


(function () {
  const ecHashTabsInit = () => {
    const ecHash = window.location.hash.replace('#', '');
    if (!ecHash) return;

    const ecTabTriggers = document.querySelectorAll(
      `.w-tab-link#${CSS.escape(ecHash)}`
    );

    if (!ecTabTriggers.length) return;

    ecTabTriggers.forEach((trigger) => {
      const ecTabsWrapper = trigger.closest('.w-tabs');
      if (!ecTabsWrapper) return;

      const ecTabIndex = trigger.getAttribute('data-w-tab');
      if (!ecTabIndex) return;

      const ecTabLinks = ecTabsWrapper.querySelectorAll('.w-tab-link');
      const ecTabPanes = ecTabsWrapper.querySelectorAll('.w-tab-pane');

      ecTabLinks.forEach((link) => link.classList.remove('w--current'));
      ecTabPanes.forEach((pane) => pane.classList.remove('w--tab-active'));

      trigger.classList.add('w--current');

      const ecActivePane = ecTabsWrapper.querySelector(
        `.w-tab-pane[data-id="${CSS.escape(ecHash)}"][data-w-tab="${ecTabIndex}"]`
      );

      if (ecActivePane) {
        ecActivePane.classList.add('w--tab-active');
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ecHashTabsInit);
  } else {
    ecHashTabsInit();
  }

  window.addEventListener('hashchange', ecHashTabsInit);
})();


(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const ecTabPanes = document.querySelectorAll('.w-tab-pane');

    ecTabPanes.forEach((pane, index) => {
      const sliderEl = pane.querySelector('.ec_tabs-slides.swiper');
      if (!sliderEl) return;

      const prevEl = pane.querySelector('.ec_tabs-arrow__prev');
      const nextEl = pane.querySelector('.ec_tabs-arrow__next');
      const paginationEl = pane.querySelector('.ec_tabs-pagination');

      new Swiper(sliderEl, {
        loop: true,
        slidesPerView: 1.2,
        spaceBetween: 0,
        speed: 700,
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl
        },
        pagination: {
          el: paginationEl,
          clickable: true
        },
        breakpoints: {
          1251: {
            slidesPerView: 3.2
          },
          992: {
            slidesPerView: 2.5
          },
          769: {
            slidesPerView: 2
          },
          480: {
            slidesPerView: 1.5
          }
        },
        on: {
          init() {
            this.update();
          }
        }
      });
    });
  });
})();
// Tabs ends



// Page banner starts
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.section_header83');
  if (!sections.length) return;

  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  sections.forEach((section) => {
    const content = section.querySelector('.header83_content-block');
    const overlay = section.querySelector('.image-overlay-layer');
    const imagesLayout = section.querySelector('.header83_images-layout');

    if (!content || !overlay || !imagesLayout) return;

    if (prefersReducedMotion) {
      content.style.opacity = 1;
      overlay.style.opacity = 1;
      imagesLayout.style.transform = `
        translate3d(0,0,0)
        scale3d(1,1,1)
      `;
      return;
    }

    const START_SCALE = 3.2;
    const END_SCALE = 1;
    const SCROLL_DISTANCE = 1150;

    let startScroll = null;

    function applyStyles(progress) {
      const opacity = 1 - progress;
      const scale =
        START_SCALE + (END_SCALE - START_SCALE) * progress;

      content.style.opacity = opacity;
      overlay.style.opacity = opacity;

      imagesLayout.style.transform = `
        translate3d(0,0,0)
        scale3d(${scale}, ${scale}, 1)
        rotateX(0deg) rotateY(0deg) rotateZ(0deg)
        skew(0deg,0deg)
      `;
    }

    function update() {
      const rect = section.getBoundingClientRect();
      const scrollY = window.scrollY;

      if (rect.top <= 0 && startScroll === null) {
        startScroll = scrollY;
      }

      if (startScroll === null) {
        applyStyles(0);
        return;
      }

      if (scrollY < startScroll) {
        startScroll = null;
        applyStyles(0);
        return;
      }

      const rawProgress =
        (scrollY - startScroll) / SCROLL_DISTANCE;

      const progress = Math.min(Math.max(rawProgress, 0), 1);

      applyStyles(progress);
    }

    window.addEventListener('scroll', () => {
      requestAnimationFrame(update);
    });

    update();
  });
});
// Page banner ends



// Contact starts
$(document).ready(function () {
  const contactCheckbox = $('.ec_contact-form__checkbox');
  const contactButton = $('.ec_contact-form__button');
  const contactCheckmark = $('.ec_contact-form__checkmark');

  function contactToggleButtonState() {
    if (contactCheckbox.is(':checked')) {
      contactButton.prop('disabled', false).removeClass('is-disabled');
      contactCheckmark.addClass('w--redirected-checked');
    } else {
      contactButton.prop('disabled', true).addClass('is-disabled');
      contactCheckmark.removeClass('w--redirected-checked');
    }
  }

  contactToggleButtonState();

  contactCheckbox.on('change', contactToggleButtonState);
});
// Contact starts



// Story starts
// (function () {
//   const section = document.querySelector('.ec_story');
//   const card1 = document.querySelector('.ec_story-page__1');
//   const card2 = document.querySelector('.ec_story-page__2');

//   if (!section || !card1 || !card2) return;

//   const vh = window.innerHeight;

//   function animateCard(card, startOffset) {
//     const sectionRect = section.getBoundingClientRect();
//     const scrollIntoSection = -sectionRect.top - startOffset;
//     const progress = Math.min(
//       Math.max(scrollIntoSection / vh, 0),
//       1
//     );

//     card.style.willChange = 'transform';
//     card.style.transform =
//       `translate3d(0, ${-100 * progress}vh, 0)`;
//   }

//   function onScroll() {
//     requestAnimationFrame(() => {
//       animateCard(card1, 0);
//       animateCard(card2, vh);
//     });
//   }

//   window.addEventListener('scroll', onScroll);
//   onScroll();
// })();
// Story ends



// Faqs starts
$(document).ready(function () {
  $('.ec_faqs-main__button').on('click', function (e) {
    e.preventDefault();

    var target = $(this).data('main');

    $('.ec_faqs-main__button').removeClass('w--current').attr({
      'aria-selected': 'false',
      'tabindex': '-1'
    });
    $(this).addClass('w--current').attr({
      'aria-selected': 'true',
      'tabindex': '0'
    });
    $('.ec_faqs-main__body').removeClass('w--tab-active').css({
      opacity: '0',
      transition: ''
    });
    $('.ec_faqs-main__body[data-body="' + target + '"]').addClass('w--tab-active').css({
      opacity: '1',
      transition: 'all, opacity 300ms'
    });
  });
});


$(document).ready(function () {
  $('.ec_faqs-tab').on('click', function (e) {
    e.preventDefault();

    var target = $(this).data('tab');

    $('.ec_faqs-tab').removeClass('w--current').attr({
      'aria-selected': 'false',
      'tabindex': '-1'
    });
    $(this).addClass('w--current').attr({
      'aria-selected': 'true',
      'tabindex': '0'
    });
    $('.ec_faqs-content').removeClass('w--tab-active').css({
      opacity: '0',
      transition: ''
    });
    $('.ec_faqs-content[data-content="' + target + '"]').addClass('w--tab-active').css({
      opacity: '1',
      transition: 'all, opacity 300ms'
    });
  });
});


$(document).ready(function () {
  $('.ec_faqs-faq__question').on('click', function () {
    var $currentQuestion = $(this);
    var $currentAnswer = $currentQuestion.next('.ec_faqs-faq__answer');
    var $currentIcon = $currentQuestion.find('.faq6_icon-wrapper');

    $('.ec_faqs-faq__answer').not($currentAnswer).slideUp(300);
    $('.faq6_icon-wrapper').not($currentIcon).removeClass('rotate');
    $currentAnswer.slideToggle(300);
    $currentIcon.toggleClass('rotate');
  });
});


$(document).ready(function () {
  $('.ec_faqs-main__button').on('click', function (e) {
    e.preventDefault();

    var mainData = $(this).data('main');

    $(this).trigger('click.tabs');

    var $firstInnerTab = $('.ec_faqs-tab').filter(function () {
      return $(this).data('tab').startsWith(mainData + '-');
    }).first();

    if ($firstInnerTab.length) {
      $firstInnerTab.trigger('click');
    }
  });
});
// Faqs ends



// Collection tabs starts
(function () {
  const initEcCTabs = () => {
    document.querySelectorAll('.w-tabs').forEach((tabsWrapper) => {
      const tabs = tabsWrapper.querySelectorAll('.ec_ctabs-tab');
      const panes = tabsWrapper.querySelectorAll('.ec_ctabs-content');

      if (!tabs.length || !panes.length) return;

      const activateTab = (tab) => {
        const key = tab.getAttribute('data-tab');
        if (!key) return;

        tabs.forEach(t => {
          t.classList.remove('w--current');
          t.setAttribute('aria-selected', 'false');
          t.setAttribute('tabindex', '-1');
        });

        panes.forEach(p => p.classList.remove('w--tab-active'));

        tab.classList.add('w--current');
        tab.setAttribute('aria-selected', 'true');
        tab.removeAttribute('tabindex');

        const activePane = tabsWrapper.querySelector(
          `.ec_ctabs-content[data-content="${key}"]`
        );

        if (activePane) {
          activePane.classList.add('w--tab-active');

          const swiperEl = activePane.querySelector('.swiper');
          if (swiperEl && swiperEl.swiper) {
            swiperEl.swiper.update();
          }
        }
      };

      tabs.forEach(tab => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          activateTab(tab);

          if (tab.id) {
            history.replaceState(null, '', `#${tab.id}`);
          }
        });
      });

      const hash = window.location.hash.replace('#', '');
      if (hash) {
        const hashTab = tabsWrapper.querySelector(`#${CSS.escape(hash)}`);
        if (hashTab) activateTab(hashTab);
      }
    });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initEcCTabs)
    : initEcCTabs();
})();


(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const ecCTabPanes = document.querySelectorAll('.ec_ctabs-content');

    ecCTabPanes.forEach((pane, index) => {
      const CsliderEl = pane.querySelector('.ec_ctabs-slides.swiper');
      if (!CsliderEl) return;

      const CprevEl = pane.querySelector('.ec_ctabs-arrow__prev');
      const CnextEl = pane.querySelector('.ec_ctabs-arrow__next');

      new Swiper(CsliderEl, {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 36,
        speed: 700,
        navigation: {
          prevEl: CprevEl,
          nextEl: CnextEl
        },
        breakpoints: {
          1280: {
            slidesPerView: 4.3
          },
          992: {
            slidesPerView: 3.2
          },
          640: {
            slidesPerView: 2.2
          }
        },
        on: {
          init() {
            this.update();
          }
        }
      });
    });
  });
})();
// Collection tabs ends



// Product card starts
document.addEventListener('submit', function (event) {
  const form = event.target;

  if (!form.matches('form.ec_pro-form[action="/cart/add"]')) return;

  event.preventDefault();

  const formData = new FormData(form);
  const submitButton = form.querySelector('.ec_pro-button__js');
  
  if (submitButton) {
    submitButton.classList.add('loading');
    submitButton.disabled = true;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then(() => {
      return fetch(
        `${window.Shopify.routes.root}?sections=cart-drawer`
      );
    })
    .then(res => res.json())
    .then(sections => {
      if (sections['cart-drawer']) {
        const temp = document.createElement('div');
        temp.innerHTML = sections['cart-drawer'];
        const newDrawerHTML = temp.querySelector('cart-drawer')?.innerHTML;
        
        if (newDrawerHTML) {
          const drawer = document.querySelector('cart-drawer');
          if (drawer) {
            drawer.innerHTML = newDrawerHTML;
            drawer.classList.add('active', 'animate');
          }
        }
      }
    })
    .then(() => {
      return fetch('/cart.js');
    })
    .then(res => res.json())
    .then(cart => {
      document.querySelectorAll('.es_header-cart__count').forEach(bubble => {
        bubble.textContent = cart.item_count;
      });
    })
    .catch(error => {
      console.error('Error:', error);
    })
    .finally(() => {
      if (submitButton) {
        submitButton.classList.remove('loading');
        submitButton.disabled = false;
      }
    });
});
// Product card ends



// Cart page starts
// document.addEventListener('DOMContentLoaded', () => {
//   const blocks = document.querySelectorAll('.es_main_cart-condition');
//   const checkoutBtn = document.querySelector('.es_main_cart-checkout__button');
//   const MIN_CHARS = 3;

//   if (!blocks.length || !checkoutBtn) return;

//   const vatPatterns = {
//     'AT': /^ATU\d{8}$/,  // Austria
//     'BE': /^BE0\d{9}$/,  // Belgium
//     'BG': /^BG\d{9,10}$/, // Bulgaria
//     'CY': /^CY\d{8}[A-Z]$/, // Cyprus
//     'CZ': /^CZ\d{8,10}$/, // Czech Republic
//     'DE': /^DE\d{9}$/,  // Germany
//     'DK': /^DK\d{8}$/,  // Denmark
//     'EE': /^EE\d{9}$/,  // Estonia
//     'EL': /^EL\d{9}$/,  // Greece (EL)
//     'ES': /^ES[A-Z0-9]\d{7}[A-Z0-9]$/, // Spain
//     'FI': /^FI\d{8}$/,  // Finland
//     'FR': /^FR[A-Z0-9]{2}\d{9}$/, // France
//     'GB': /^GB(\d{9}|\d{12}|GD\d{3}|HA\d{3})$/, // United Kingdom
//     'HR': /^HR\d{11}$/, // Croatia
//     'HU': /^HU\d{8}$/,  // Hungary
//     'IE': /^IE(\d{7}[A-Z]{1,2}|[A-Z]\d{7}[A-Z])$/, // Ireland
//     'IT': /^IT\d{11}$/, // Italy
//     'LT': /^LT(\d{9}|\d{12})$/, // Lithuania
//     'LU': /^LU\d{8}$/,  // Luxembourg
//     'LV': /^LV\d{11}$/, // Latvia
//     'MT': /^MT\d{8}$/,  // Malta
//     'NL': /^NL\d{9}B\d{2}$/, // Netherlands
//     'PL': /^PL\d{10}$/, // Poland
//     'PT': /^PT\d{9}$/,  // Portugal
//     'RO': /^RO\d{2,10}$/, // Romania
//     'SE': /^SE\d{12}$/, // Sweden
//     'SI': /^SI\d{8}$/,  // Slovenia
//     'SK': /^SK\d{10}$/, // Slovakia
//   };

//   function validateVATNumber(vatNumber) {
//     if (!vatNumber || vatNumber.trim() === '') return false;
    
//     const cleanVAT = vatNumber.toUpperCase().replace(/[\s\-\.]/g, '');
    
//     const countryCode = cleanVAT.substring(0, 2);
    
//     if (!vatPatterns[countryCode]) return false;
    
//     return vatPatterns[countryCode].test(cleanVAT);
//   }

//   function validateAllBlocks() {
//     let allValid = true;

//     blocks.forEach(block => {
//       if (block.style.display === 'none') return;
      
//       const input = block.querySelector('.es_condition-input');
//       const errorMessage = block.querySelector('.es_main_cart-condition__error');
//       const successMessage = block.querySelector('.es_main_cart-condition__success');

//       if (!input) return;

//       const value = input.value.trim();
//       let isValid = false;
      
//       const isEUBlock = input.id === 'condition-eu-input' || 
//                         block.classList.contains('es_main_cart-condition__eu');
      
//       if (isEUBlock) {
//         isValid = validateVATNumber(value);
//       } else {
//         isValid = value.length >= MIN_CHARS;
//       }

//       if (!isValid) allValid = false;

//       if (errorMessage) errorMessage.style.display = isValid ? 'none' : 'block';
//       if (successMessage) successMessage.style.display = isValid ? 'block' : 'none';

//       input.classList.toggle('valid', isValid);
//       input.classList.toggle('invalid', !isValid);
//     });

//     checkoutBtn.disabled = !allValid;
//     checkoutBtn.classList.toggle('enabled', allValid);
//     checkoutBtn.classList.toggle('disabled', !allValid);
//   }

//   blocks.forEach(block => {
//     const input = block.querySelector('.es_condition-input');
//     if (!input) return;

//     const attributeKey = input.dataset.cartAttribute;
//     if (!attributeKey) return;

//     validateAllBlocks();

//     let saveTimeout;
//     input.addEventListener('input', () => {
//       clearTimeout(saveTimeout);
//       const value = input.value.trim();

//       validateAllBlocks();

//       saveTimeout = setTimeout(() => {
//         const updateData = {
//           attributes: {
//             [attributeKey]: value || ''
//           }
//         };
        
//         fetch('/cart/update.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify(updateData)
//         }).catch(error => console.error('Error updating cart:', error));
//       }, 800);
//     });
    
//     input.addEventListener('blur', validateAllBlocks);
//   });

//   const euInput = document.querySelector('#condition-eu-input');
//   if (euInput) {
//     euInput.addEventListener('input', function() {
//       let value = this.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      
//       if (value.length >= 2) {
//         value = value.substring(0, 2) + ' ' + value.substring(2);
//       }
      
//       this.value = value;
//     });
//   }
// });
document.addEventListener('DOMContentLoaded', () => {
  const blocks = document.querySelectorAll('.es_main_cart-condition');
  const checkoutBtn = document.querySelector('.es_main_cart-checkout__button');
  const MIN_CHARS = 3;

  if (!blocks.length || !checkoutBtn) return;

  const vatPatterns = {
    'AT': /^ATU\d{8}$/,  // Austria
    'BE': /^BE0\d{9}$/,  // Belgium
    'BG': /^BG\d{9,10}$/, // Bulgaria
    'CY': /^CY\d{8}[A-Z]$/, // Cyprus
    'CZ': /^CZ\d{8,10}$/, // Czech Republic
    'DE': /^DE\d{9}$/,  // Germany
    'DK': /^DK\d{8}$/,  // Denmark
    'EE': /^EE\d{9}$/,  // Estonia
    'EL': /^EL\d{9}$/,  // Greece (EL)
    'ES': /^ES[A-Z0-9]\d{7}[A-Z0-9]$/, // Spain
    'FI': /^FI\d{8}$/,  // Finland
    'FR': /^FR[A-Z0-9]{2}\d{9}$/, // France
    'GB': /^GB(\d{9}|\d{12}|GD\d{3}|HA\d{3})$/, // United Kingdom
    'HR': /^HR\d{11}$/, // Croatia
    'HU': /^HU\d{8}$/,  // Hungary
    'IE': /^IE(\d{7}[A-Z]{1,2}|[A-Z]\d{7}[A-Z])$/, // Ireland
    'IT': /^IT\d{11}$/, // Italy
    'LT': /^LT(\d{9}|\d{12})$/, // Lithuania
    'LU': /^LU\d{8}$/,  // Luxembourg
    'LV': /^LV\d{11}$/, // Latvia
    'MT': /^MT\d{8}$/,  // Malta
    'NL': /^NL\d{9}B\d{2}$/, // Netherlands
    'PL': /^PL\d{10}$/, // Poland
    'PT': /^PT\d{9}$/,  // Portugal
    'RO': /^RO\d{2,10}$/, // Romania
    'SE': /^SE\d{12}$/, // Sweden
    'SI': /^SI\d{8}$/,  // Slovenia
    'SK': /^SK\d{10}$/, // Slovakia
  };

  function validateVATNumber(vatNumber) {
    if (!vatNumber || vatNumber.trim() === '') return false;
    
    const cleanVAT = vatNumber.toUpperCase().replace(/[\s\-\.]/g, '');
    
    const countryCode = cleanVAT.substring(0, 2);
    
    if (!vatPatterns[countryCode]) return false;
    
    return vatPatterns[countryCode].test(cleanVAT);
  }

  function validateAllBlocks() {
    let allValid = true;

    blocks.forEach(block => {
      if (block.style.display === 'none') return;
      
      const input = block.querySelector('.es_condition-input');
      const errorMessage = block.querySelector('.es_main_cart-condition__error');
      const successMessage = block.querySelector('.es_main_cart-condition__success');

      if (!input) return;

      const value = input.value.trim();
      let isValid = false;
      
      const isEUBlock = input.id === 'condition-eu-input' || 
                        block.classList.contains('es_main_cart-condition__eu');
      
      if (isEUBlock) {
        isValid = validateVATNumber(value);
      } else {
        isValid = value.length >= MIN_CHARS;
      }

      if (!isValid) allValid = false;

      if (errorMessage) errorMessage.style.display = isValid ? 'none' : 'block';
      if (successMessage) successMessage.style.display = isValid ? 'block' : 'none';

      input.classList.toggle('valid', isValid);
      input.classList.toggle('invalid', !isValid);
    });

    checkoutBtn.disabled = !allValid;
    checkoutBtn.classList.toggle('enabled', allValid);
    checkoutBtn.classList.toggle('disabled', !allValid);
  }

  blocks.forEach(block => {
    const input = block.querySelector('.es_condition-input');
    if (!input) return;

    const attributeKey = input.dataset.cartAttribute;
    if (!attributeKey) return;

    validateAllBlocks();

    let saveTimeout;
    input.addEventListener('input', () => {
      clearTimeout(saveTimeout);
      const value = input.value.trim();

      validateAllBlocks();

      saveTimeout = setTimeout(() => {
        const updateData = {
          attributes: {
            [attributeKey]: value || ''
          }
        };
        
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updateData)
        }).catch(error => console.error('Error updating cart:', error));
      }, 800);
    });
    
    input.addEventListener('blur', validateAllBlocks);
  });

  const euInput = document.querySelector('#condition-eu-input');
  if (euInput) {
    euInput.addEventListener('input', function() {
      let value = this.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      
      if (value.length >= 2) {
        value = value.substring(0, 2) + ' ' + value.substring(2);
      }
      
      this.value = value;
    });
  }

  const nonEUEuropeanCountries = [
    'CH',  // Switzerland
    'NO',  // Norway
    'IS',  // Iceland
    'LI',  // Liechtenstein
    'MC'   // Monaco
  ];

  const euCountries = [
    'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR',
    'DE','GR','HU','IE','IT','LV','LT','LU','MT','NL',
    'PL','PT','RO','SK','SI','ES','SE'
  ];

  function setNonEUEuropeanFlag() {
    fetch('https://ipwhois.pro/?key=O8CEvYPOv9NpxYGO')
      .then(response => response.json())
      .then(data => {
        console.log('Detected IP country:', data.country_code);
        
        if (nonEUEuropeanCountries.includes(data.country_code)) {
          console.log('Non-EU European country detected. Setting export flag.');
          
          const updateData = {
            attributes: {
              'non_eu_european': 'true',
              'eu_vat_number_seller': 'NL827228843B01',
              'vat_treatment': 'Export 0% VAT'
            }
          };
          
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updateData)
          }).catch(error => console.error('Error updating cart with export info:', error));
        }
        
        if (euCountries.includes(data.country_code) || nonEUEuropeanCountries.includes(data.country_code)) {
          document.querySelectorAll('.es_main_cart-condition__eu')
            .forEach(el => el.style.display = 'block');
        }
      })
      .catch(err => {
        console.error('IP detection failed:', err);
      });
  }

  setNonEUEuropeanFlag();
});
// Cart page ends



// Register starts
$(document).ready(function () {
  const contactCheckbox = $('.ec_register-form__checkbox');
  const contactButton = $('.ec_register-form__button');

  function contactToggleButtonState() {
    if (contactCheckbox.is(':checked')) {
      contactButton.prop('disabled', false).removeClass('is-disabled');
      contactCheckmark.addClass('w--redirected-checked');
    } else {
      contactButton.prop('disabled', true).addClass('is-disabled');
    }
  }

  contactToggleButtonState();

  contactCheckbox.on('change', contactToggleButtonState);
});
// Register ends



// Main product starts
document.addEventListener("DOMContentLoaded", () => {
  const productSwiper = new Swiper(".ec_main_product-slides", {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 400,
    loop: false,
    effect: "fade",
    autoHeight: true,
    navigation: {
      prevEl: ".ec_main_product-slider__prev",
      nextEl: ".ec_main_product-slider__next"
    },
    pagination: {
      el: ".ec_main_product-slider__pagination",
      clickable: true,
    },
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    observer: true,
    observeParents: true,
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const swiper = document.querySelector(".ec_main_product-slides")?.swiper;
  if (!swiper) return;

  const thumbnails = document.querySelectorAll(".ec_main_product-thumbnail__item");

  thumbnails.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const targetId = thumb.dataset.target;
      if (!targetId) return;

      const slides = document.querySelectorAll(".ec_main_product-slide");

      slides.forEach((slide, index) => {
        slide.classList.remove("is-active");

        if (slide.dataset.mediaId === targetId) {
          slide.classList.add("is-active");
          swiper.slideTo(index, 0);
        }
      });
    });
  });
});


$(document).ready(function() {
  $('.ec_main_product-accordion__header').click(function() {
    const $thisAccordion = $(this).closest('.ec_main_product-accordion');
    const $accordionBody = $thisAccordion.find('.ec_main_product-accordion__body');
    
    if ($thisAccordion.hasClass('active')) {
      $thisAccordion.removeClass('active');
      $accordionBody.slideUp(300);
    } 
    else {
      $('.ec_main_product-accordion').removeClass('active');
      $('.ec_main_product-accordion__body').slideUp(300);
      $thisAccordion.addClass('active');
      $accordionBody.slideDown(300);
    }
  });
});
// Main product ends



// Htabs starts
$(document).on("click", ".ec_asset-button, .ec_asset-close", function (e) {
  e.preventDefault();

  const $body = $("body");

  if ($(this).hasClass("ec_asset-button")) {
    const $popup = $(this).closest(".dp-content").next(".ec_asset-popup");

    $body.addClass("ec_body-hidden");

    $(".ec_asset-popup").hide();

    $popup.fadeIn(200);
  }

  if ($(this).hasClass("ec_asset-close")) {
    $body.removeClass("ec_body-hidden");

    $(this).closest(".ec_asset-popup").fadeOut(200);
  }
});
// Htabs ends



// Vtabs starts
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ec_vtabs-hub__main').forEach((hub) => {
    const sliderEl = hub.querySelector('.ec_vtabs-hub__slider');
    const prevEl = hub.querySelector('.ec_vtabs-hub__arrow-prev');
    const nextEl = hub.querySelector('.ec_vtabs-hub__arrow-next');
    const paginationEl = hub.querySelector('.ec_vtabs-hub__pagination');

    if (!sliderEl) return;

    new Swiper(sliderEl, {
      loop: false,
      slidesPerView: 2.2,
      spaceBetween: 25,
      speed: 700,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3.2,
        },
        992: {
          slidesPerView: 4.2,
        }
      }
    });
  });
});
// Vtabs ends
